import { FetchAPI } from "api/fetch";

export const getWizardDataService = async (url) => {
  const productsView = await FetchAPI(url);
  const productsViewJson = await productsView.json();
    return productsViewJson;
};